import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import PreviewCard from './preview_card.jsx';

import { SMALL_ICON_BASE_SRC, } from '../../../Shared'
import { requestGet } from '../../../../modules/request';

interface ArticleSpotlightProps {
  blogPostId: string
}

export const ArticleSpotlight = ({ blogPostId } : ArticleSpotlightProps ) => {
  const [blogPost, setBlogPost] = React.useState(null);
  const [blogPostAuthor, setBlogPostAuthor] = React.useState(null);

  React.useEffect(() => {
    getBlogPost(blogPostId)
  }, [])

  function getBlogPost(id: string) {
    requestGet(`/featured_blog_post/${id}`,
      (data) => {
        if(data.blog_post) {
          const { blog_post, author } = data;
          setBlogPost(blog_post)
          setBlogPostAuthor(author)
        }
      }
    )
  }

  function renderPreviewContent({ title, slug, preview_card_content, external_link, footer_content }) {
    if(footer_content) {
      return(
        <section className="content-section">
          <h4>{title}</h4>
          <div className="preview-card">
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>{footer_content}</ReactMarkdown>
          </div>
          <section className="footer-section">
            {blogPostAuthor && <p className="author">{`By ${blogPostAuthor}`}</p>}
            <a className="quill-button-archived contained primary fun" href={`${teacherCenterBaseUrl}/${slug}`} rel="noopener noreferrer" target="_blank">Read</a>
          </section>
        </section>
      )
    }
    return(
      <PreviewCard
        content={preview_card_content}
        externalLink={!!external_link}
        key={title}
        link={external_link ? external_link : `/teacher-center/${slug}`}
      />
    )
  }

  if(!blogPost) { return <span /> }

  const teacherCenterBaseUrl = `${window.postbuildEnv.DEFAULT_URL}/teacher-center`;

  return(
    <aside className="article-spotlight-container">
      <div className="inner-container">
        <div className="upper-section">
          <section className="header-section">
            <h2><img alt="" src={`${SMALL_ICON_BASE_SRC}/lightbulb.svg`} />Check out this helpful article</h2>
            <p>Want more guidance with your implementation of Quill? Check out these articles written by Quill&apos;s instructional coaches and curriculum team.</p>
          </section>
          <a className="quill-button contained small green focus-on-light" href={teacherCenterBaseUrl} rel="noopener noreferrer" target="_blank">Show more</a>
        </div>
        {renderPreviewContent(blogPost)}
      </div>
    </aside>
  )
}

export default ArticleSpotlight;
